import { useCallback, useSyncExternalStore } from 'react';
import { toLoading, toEmpty } from '../resolvers/definition/resolverState';
import { useKey } from './useKey';
import { getPulseClient } from '../client/client';
export const initial = Object.freeze(toLoading()());
export const skipped = toEmpty()();
export const skipToken = Symbol.for('pulse.skipToken');
export const isSkipToken = value => value === skipToken;
export const emptyInitialParams = Object.freeze({});
export const usePulseClient = () => getPulseClient();
export const normalizeResourceOptions = options => {
  var _options$params;
  const skipTokenPassed = isSkipToken(options === null || options === void 0 ? void 0 : options.params);
  const params = skipTokenPassed ? emptyInitialParams : (_options$params = options === null || options === void 0 ? void 0 : options.params) !== null && _options$params !== void 0 ? _options$params : emptyInitialParams;
  const skip = !!(options !== null && options !== void 0 && options.skip) || skipTokenPassed;
  return {
    params,
    skip,
    pollInterval: options === null || options === void 0 ? void 0 : options.pollInterval,
    pollGroup: options === null || options === void 0 ? void 0 : options.pollGroup,
    httpClient: options === null || options === void 0 ? void 0 : options.httpClient
  };
};
export const useParseOptions = (resource, options) => {
  const {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient
  } = normalizeResourceOptions(options);
  const instanceKey = useKey(resource, params);
  return {
    params,
    skip,
    pollInterval,
    pollGroup,
    httpClient,
    instanceKey
  };
};
export const useSyncResource = (getSnapshot, instanceKey, resource, params, skip, pollInterval, client, httpClient, pollGroup) => {
  const subscribe = useCallback(callback => {
    if (skip || !client) {
      return () => {};
    }
    return client.watch({
      resource,
      params,
      instanceKey,
      pollInterval,
      httpClient,
      pollGroup
    }, callback);
  },
  // instanceKey is a proxy for params and resource type changing
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [client, instanceKey, pollInterval, pollGroup, skip]);
  return useSyncExternalStore(subscribe, getSnapshot, getSnapshot);
};